import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Typography, Space, Input, Row, Col } from 'antd';

import { CommonFormProps, OnboardingLayout } from '.';
import { BackButton, Form } from '~/components';
import { authenticateEmailOtp } from '~/api/onboarding';
import { auth } from '~/api/axios';
import { useOnboardingPage, useOnboardingState } from '~/hooks/onboarding';
import onError from '~/errorsHandler';

const { Title, Text } = Typography;

const ConfirmEmail: FC<CommonFormProps> = (props) => {
  const { name } = props;
  const { t } = useTranslation('onboarding');
  const dt = (key: string): string => t(`translation:${key}`);
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState(false);
  const [tooManyAttempts, setTooManyAttempts] = useState(false);

  const [createAccountState, setCreateAccountState] = useOnboardingState('createAccount');
  const [, setPageState] = useOnboardingState(name);
  const email = createAccountState.formData?.email;

  const onboardingPage = useOnboardingPage(name);

  const onFinish = async (values: any) => {
    const { code } = values;
    const challengeToken = createAccountState.formData?.challengeToken;

    if (code && challengeToken) {
      try {
        setLoading(true);
        const { headers } = await authenticateEmailOtp(challengeToken, code);
        auth.setToken(headers, 'emailOtp');
        onboardingPage.activateNext();
        onboardingPage.goNext();
        setCreateAccountState((prev) => ({
          ...prev,
          disabled: true,
        }));
        setPageState((prev) => ({
          ...prev,
          disabled: true,
        }));
      } catch (error: any) {
        onError(error);
        if ((error as any)?.response?.data?.message?.indexOf('Too many attempts') >= 0) {
          setTooManyAttempts(true);
          onboardingPage.goBack();
        }
      }
      setLoading(false);
    }
  };
  return (
    <OnboardingLayout>
      <Title level={2}>{t('confimEmail')}</Title>
      <Space size="middle" direction="vertical">
        <Text>{`${t('enterEmailOtp')} ${email}`}</Text>
        <Form form={form} layout="vertical" size="large" onFinish={onFinish}>
          <Form.Item name="code" rules={[{ required: true, min: 5 }]}>
            <Input placeholder={dt('otpCode')} />
          </Form.Item>
          <Row gutter={16}>
            <Col>
              <BackButton />
            </Col>
            <Col>
              <Form.Item noStyle>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isLoading}
                  disabled={tooManyAttempts}
                >
                  {dt('confirm')}
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Space>
    </OnboardingLayout>
  );
};

export default ConfirmEmail;
